import createStore from './createStore';

const store = createStore({
  storeName: 'paymentMethodToggle',
  initialState: {
    isEnabled: false
  },
  reducers: {
    enable(state, action) {
      state.isEnabled = true;
    },
    disable(state, action) {
      state.isEnabled = false;
    },
    toggle(state, action) {
      state.isEnabled = !state.isEnabled;
    },
    set(state, action) {
      state.isEnabled = action.isEnabled;
    }
  }
});

export default store.reducer;
export const actions = store.actions;
export const usePaymentMethodToggleStore = store.useStore;
